import React from 'react'
import PropTypes from 'prop-types'
import buildPosition from 'letter/components/header/util/buildPosition'
import buildStyles from 'letter/components/header/util/buildStyles'

const HeaderItemImage = ({ data }) => {
  const {
    type,
    x,
    y,
    sortId,
    metaData: {
      font,
      fontSize,
      fontWeight,
      italic,
      underline,
      color,
      width,
      height,
      html,
    },
  } = data

  const position = buildPosition({ x, y, width, height, sortId, type })
  const styling = buildStyles({ font, fontSize, fontWeight, italic, underline, color })
  const finalStyles = Object.assign({}, position, styling)

  return (
    <span style={finalStyles}>{html}</span>
  )
}

HeaderItemImage.propTypes = {
  data: PropTypes.object,
}

export default HeaderItemImage
